import React, { HTMLAttributes, ReactNode } from 'react';

interface LinkProps extends HTMLAttributes<HTMLAnchorElement> {
    linkStyles?: string
    className?: string
    children?: ReactNode
    url?: string
    target?: boolean
}

const SnippetLink = (props: LinkProps) => {
    const { linkStyles = "primary", className, children, url, target = false, ...restProps } = props

    // Only render if both children and url are provided
    if (!children || !url) {
        return null;
    }

    const buttonStyle = "attrax-button-" + linkStyles;

    return (
        <a
            className={buttonStyle + " " + className}
            href={url}
            target={target ? '_blank' : '_self'}
            rel={target ? 'noopener noreferrer' : undefined}
            {...restProps}
        >
            {children}
        </a>
    )
}

export default SnippetLink